<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
const { logout, isAuthenticated } = useAuth0();

const handleLogout = () => {
  logout({ logoutParams: { returnTo: window.location.origin } });
};
</script>

<template>
  <div>
    <div class="header grid-x">
      <div class="grid-x cell small-offset-0 small-12 medium-offset-1 medium-10 large-offset-1 large-10 white-section">
        <div id="head-logo-mobile" class="show-for-small-only">
        </div>
        <div id="head-logo" class="cell medium-4 large-4 hide-for-small-only">
        </div>
        <div class="cell medium-8 large-8 hide-for-small-only">
          <ul v-show="isAuthenticated" id="head-menu-list">
            <a href="#">
              <li>
                <font-awesome-icon :icon="['fas', 'house']" />
                <span>Home</span>
              </li>
            </a>
            <a href="#/profile">
              <li>
                <font-awesome-icon :icon="['fas', 'user']" />
                <span>Profile</span>
              </li>
            </a>
            <a @click="handleLogout">
              <li>
                <font-awesome-icon :icon="['fas', 'arrow-right-from-bracket']" />
                <span>Logout</span>
              </li>
            </a>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../assets/styles/header.scss";
</style>
